import cn from '../utils/tailwind/cn'
import * as React from 'react'

export function ButtonIcon({
  onClick,
  disabled,
  children,
  className,
  loading,
  hoverColor,
  rounded,
}) {
  const roundedClass = rounded ? 'rounded-full' : 'rounded-md'
  const classes = disabled
    ? `py-2 px-2 ${roundedClass} text-gray-500 bg-white/50`
    : `py-2 px-2 ${roundedClass} text-gray-500 hover:bg-${
        hoverColor || 'dark-10'
      } focus:outline-none focus:border-gray-100 focus:shadow-outline-blue active:bg-gray-200 transition duration-150 ease-in-out`

  return (
    <button
      className={cn(classes, className)}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default ButtonIcon
